
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-page",
      function () {
        return require("private-next-pages/landing-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-page"])
      });
    }
  